import { RouteConfig } from 'vue-router';
// import MswProducts from './msw-products.vue';
import MswProductsTab from './components/products-tab.vue';
import RegisterProducts from './components/register-products.vue';
import MswIPT from './components/IPTacceptOrReject.vue';
import MswITT from './components/ITTacceptOrReject.vue';
import MultiActivationStatus from './components/msw-bulkactivation/multiactivationstatus.vue';
import GetMaintainanceKey from './components/get-maintainance-key.vue';

export const productsTab: RouteConfig = {
  path: 'products',
  component: MswProductsTab,
};

export const registerProductTab: RouteConfig = {
  path: 'register-products',
  component: RegisterProducts,
};

export const iptApproveOrReject: RouteConfig = {
  path: 'IptTransfer',
  component: MswIPT,
};

export const ittApproveOrReject: RouteConfig = {
  path:'IttTransfer',
  component: MswITT,
};

export const getMaintainanceKeyTab: RouteConfig = {
  path: 'get-maintainance-key',
  component: GetMaintainanceKey,
};

export const multiServiceActivationTab: RouteConfig = {
  path:'multiactivationstatus',
  component:MultiActivationStatus,
};

// export default routes;
